import { Reducer as Reducer_ } from 'redux';
import { IAntiVirusActionType as IAntiVirusActionType_ } from '../actions/anti-virus-actions';
import * as types from '../actions/actionTypes/anti-virus';
import AntivirusResponseModel_ from '../../data/models/AntivirusResponse';

/* eslint-disable max-len */
const antiVirusReducer: Reducer_<AntivirusResponseModel_, IAntiVirusActionType_> = (state = { HasThreat: false, FileName: '', }, { type, payload, }) => {
  switch (type) {
    case types.SET_ANTIVIRUS_STATUS:
      return { ...payload, };

    default:
      return state;
  }
};

export default antiVirusReducer;
